import React, { useEffect } from 'react';

import Actions from '../action';
import CompanyInfoPresentational from '../Components/companyinfopresentational';
import Selectors from '../selectors';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

const CompanyInfoFunctional = ({
	allowNavigate,
	navigateDisabled,
	buttonMode,
	buttonName,
	getCompanyList,
	getCompanyInfoStart,
	companyInfoData,
	isCompanyLoading,
	setCompanyInfoStart,
	savingCompanyInfoData,
	savingStatus,
	setCompanyInfoReset,
}) => {
	const { companyId } = useParams();
	useEffect(() => {
		allowNavigate?.(0);
		buttonMode?.('single');
		buttonName?.('Next');
		getCompanyInfoStart(companyId);
	}, []);
	return (
		<CompanyInfoPresentational
			navigateDisabled={navigateDisabled}
			getCompanyList={getCompanyList}
			companyInfoData={companyInfoData}
			isCompanyLoading={isCompanyLoading}
			{...{ setCompanyInfoStart, savingCompanyInfoData, savingStatus, setCompanyInfoReset }}
		/>
	);
};
const mapStateToProps = (state) => {
	return {
		opportunityData: Selectors.opportunityData(state),
		companyInfoData: Selectors.companyInfoData(state),
		savingCompanyInfoData: Selectors.savingCompanyInfoData(state),
		isCompanyLoading: Selectors.isCompanyLoading(state),
		savingStatus: Selectors.savingStatus(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getCompanyInfoStart: (companyId) => dispatch(Actions.creators.getCompanyInfoStart(companyId)),
		setCompanyInfoReset: () => dispatch(Actions.creators.setCompanyInfoReset()),
		setCompanyInfoStart: (payload, companyId) => dispatch(Actions.creators.setCompanyInfoStart(payload, companyId)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(CompanyInfoFunctional);
export default Connected;
